<template>

<div class="inputs">

     <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.inputs {
    padding: 20px 10px;
    border-bottom: 1px solid rgb(54, 97, 119);
}

.is-mobile .inputs {
    border-bottom: 1px solid #eee;
    padding: 10px;
}

</style>